import { NamedEntityDto } from './named.dto';

export class BiopsyTypeDto extends NamedEntityDto {
  requiresSizeInformation?: boolean;
}
